import React from 'react';

import { isValidUrl } from 'utilitys/helpers/general';

import useUserHook from 'hooks/useUserHook';

import { CustomizedRoundIcon } from 'components/common/CustomizedRoundIcon/CustomizedRoundIcon';
import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { TooltipSpans } from 'components/common/TooltipIcon/tooltipSpans';

import { WidgetButton } from 'components/Dashboards/Reporting/_common/widgetButtons/WidgetButton';

interface ITooltipIconProps {
    tooltip?: IToolTip;
    size?: string;
    iconSize?: string | number;
    customTriggerElement?: React.ReactNode;
    [key: string]: any;
}

export const TooltipIcon = ({
    tooltip,
    size = '4rem',
    iconSize = '1.7rem',
    customTriggerElement,
    ...rest
}: ITooltipIconProps) => {
    const { email } = useUserHook();

    return !tooltip ? null : (
        <div data-testid={'tool-tip-icon-container'}>
            <CustomizedTooltip
                tooltipContent={<TooltipSpans tooltip={tooltip} />}
                triggerElement={
                    tooltip.link && isValidUrl(tooltip.link) ? (
                        <a
                            data-testid={'tool-tip-trigger-link'}
                            href={`${tooltip.link}?email=${email}`}
                            target={'_blank'}
                            {...rest}
                        >
                            <ToolTipIcon customTriggerElement={customTriggerElement} />
                        </a>
                    ) : (
                        <ToolTipIcon customTriggerElement={customTriggerElement} />
                    )
                }
            />
        </div>
    );
};

const ToolTipIcon = ({ customTriggerElement }) => {
    if (customTriggerElement) {
        return customTriggerElement;
    }

    return <WidgetButton icon={'info_outlined'} />;
};
